// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"128":"051060de","203":"20544191","448":"b1c579f0","542":"eeecd37a","560":"41400654","781":"ab936b40","795":"b1c579f0"}[chunkId] + ".chunk.css";
};